import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { createPrompt } from "../../../api/prompts";
import { askPrompt, getMe, shouldAskQuestion, getNextQuestion } from "../../../api/sasha";

const STATIC_KEYWORDS = [
  `Draft me an Instagram post`,
  `What are the best cities for a hip-hop artist to perform in?`,
  `What are the highest revenue cities for touring country artists?`,
  `How often should a musician post to X?`,
];

export default function useSasha({ prompt }) {
  const [nextQuestion, setNextQuestion] = useState(null);
  const [data, setData] = useState(null);
  const [isShouldAskQuestion, setIsShouldAskQuestion] = useState(false);
  const [keywords, setKeywords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { chats } = useSelector((a) => a.chats || []);
  const lastSashaMsg = useMemo(() => {
    for (let i = chats.length - 1; i >= 0; i--) {
      if (!chats[i].fromMe) {
        return chats[i];
      }
    }
    return null;
  }, [chats]);

  const isSurveyAnswer = useMemo(() => {
    const question = (nextQuestion || "").toLowerCase().trim();
    const lastMsg = (lastSashaMsg?.msg || "").toLowerCase().trim();
    return question === lastMsg;
  }, [nextQuestion, lastSashaMsg]);

  useEffect(() => {
    shouldAskQuestion()
      .then(({ data }) => {
        setIsShouldAskQuestion(data.result);
      })
  }, []);

  useEffect(() => {
    if (isShouldAskQuestion === true){
    getNextQuestion()
      .then(({ data }) => {
        setNextQuestion(data.question);
      })
    }
  }, [isShouldAskQuestion]);

  useEffect(() => {
    setKeywords(STATIC_KEYWORDS);
    if (!prompt) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    askPrompt(prompt, isSurveyAnswer && lastSashaMsg ? lastSashaMsg.msg : null)
      .then(({ data }) => data.answer)
      .then(setData)
      .finally(() => {
        setIsLoading(false);
      });
  }, [prompt, lastSashaMsg, isSurveyAnswer]);

  return { data, isLoading, nextQuestion, keywords };
}
